import { Component, OnInit } from '@angular/core';
import { activation_labels } from '../../utils/constants.helper';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements OnInit {
  protected readonly labels = activation_labels.confirmation;

  cardNo!: string;

  constructor(private loginService: LoginService) {}

  ngOnInit(): void {
    this.loginService.validatedUserDetails.subscribe((data) => {
      this.cardNo = data?.sdcCardNo ?? '';
    });
  }
}
